/*
  zmiana-kodu: ZM-003 + ZM-004
  opis: Blokada 7 dni od wyświetlenia i 365 dni po zapisie;
        zamykanie poza panelem, wyniki formularza i link ?newsletter=1.
  było:
class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookie = document.cookie.includes("hideNotificationPopup=true");

    if (this.hasSubscription || this.cookie) return;

    setTimeout(() => {
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
    }, this.delay * 1000);

    this.closeBtn.addEventListener("click", () => {
      this.popup.classList.add("hidden");
      this.setCookie("hideNotificationPopup", "true", 7);
    });
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}

customElements.define("notification-popup", NotificationPopup);

*/
class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = this.closest('.not-pu-section');
    if (!this.popup) return;

    this.container = this.popup.querySelector('.newsletter__container');
    this.closeBtn = this.popup.querySelector('.newsletter__close-btn');
    this.hasSubscription = this.dataset.hasSubscription === 'true';
    this.delay = Math.max(0, Number(this.dataset.delay) || 0);
    this.forceOpen = new URLSearchParams(window.location.search).get('newsletter') === '1';

    this.handleClose = (event) => {
      event.preventDefault();
      this.hidePopup();
    };
    /*
      zmiana-kodu: ZM-003 (poprawka obsługi banera cookies)
      opis: Kliknięcia w natywny baner i preferencje Shopify nie zamykają newslettera.
      było:
    this.handleOutsideClick = (event) => {
      if (this.popup.classList.contains('hidden')) return;
      if (this.container && !this.container.contains(event.target)) this.hidePopup();
    };
    */
    this.handleOutsideClick = (event) => {
      if (this.popup.classList.contains('hidden')) return;
      const isPrivacyClick = event.composedPath().some(
        (node) => node instanceof Element && node.id.startsWith('shopify-pc__')
      );
      if (isPrivacyClick) return;
      if (this.container && !this.container.contains(event.target)) this.hidePopup();
    };
    /* koniec zmiany-kodu: ZM-003 (poprawka obsługi banera cookies) */
    this.handlePageHide = () => {
      window.clearTimeout(this.timer);
      this.hidePopup();
    };
    this.handlePageShow = (event) => {
      if (event.persisted) this.evaluateState(true);
    };

    this.closeBtn?.addEventListener('click', this.handleClose);
    document.addEventListener('click', this.handleOutsideClick, true);
    window.addEventListener('pagehide', this.handlePageHide);
    window.addEventListener('pageshow', this.handlePageShow);
    this.evaluateState(false);
  }

  evaluateState(restored) {
    window.clearTimeout(this.timer);
    const success = this.popup.querySelector('.newsletter-form .form__success-field');
    const error = this.popup.querySelector('.newsletter-form .form__error-field');

    if (success && !restored) {
      /*
        zmiana-kodu: ZM-003 (jednorazowe potwierdzenie zapisu)
        opis: Po odczytaniu wyniku usuwamy znacznik, aby odświeżenie nie otwierało podziękowania.
      */
      const resultUrl = new URL(window.location.href);
      if (resultUrl.searchParams.has('customer_posted')) {
        resultUrl.searchParams.delete('customer_posted');
        window.history.replaceState(
          window.history.state, '', resultUrl.pathname + resultUrl.search + resultUrl.hash
        );
      }
      this.setCookie('hideNotificationPopup', 'true', 365);
      this.setCookie('newsletterSubscribed', 'true', 365);
      this.showPopup();
      return;
    }
    if (error && !this.hasCookie('newsletterSubscribed')) {
      this.showPopup();
      this.setCookie('hideNotificationPopup', 'true', 7);
      return;
    }
    if (this.hasSubscription || this.hasCookie('newsletterSubscribed')) {
      this.hidePopup();
      return;
    }
    if (this.forceOpen) {
      this.openAndRemember();
      return;
    }
    if (this.hasCookie('hideNotificationPopup')) {
      this.hidePopup();
      return;
    }
    this.timer = window.setTimeout(() => this.openAndRemember(), this.delay * 1000);
  }

  openAndRemember() {
    if (!this.isConnected || this.hasSubscription || this.hasCookie('newsletterSubscribed')) return;
    if (!this.forceOpen && this.hasCookie('hideNotificationPopup')) return;
    this.showPopup();
    this.setCookie('hideNotificationPopup', 'true', 7);
  }

  showPopup() {
    this.popup.classList.remove('hidden');
    this.popup.classList.add('wt-popup-fade-in');
  }

  hidePopup() {
    this.popup.classList.add('hidden');
    this.popup.classList.remove('wt-popup-fade-in');
  }

  hasCookie(name) {
    return document.cookie.split(';').some((part) => part.trim() === name + '=true');
  }

  setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    const secure = window.location.protocol === 'https:' ? ';Secure' : '';
    document.cookie = name + '=' + value + ';expires=' + expires + ';path=/;SameSite=Lax' + secure;
  }

  disconnectedCallback() {
    window.clearTimeout(this.timer);
    this.closeBtn?.removeEventListener('click', this.handleClose);
    document.removeEventListener('click', this.handleOutsideClick, true);
    window.removeEventListener('pagehide', this.handlePageHide);
    window.removeEventListener('pageshow', this.handlePageShow);
  }
}

if (!customElements.get('notification-popup')) {
  customElements.define('notification-popup', NotificationPopup);
}
/* koniec zmiany-kodu: ZM-003 + ZM-004 */
